<!------------ START TEMPLATE ------------>
<template>
  <div>
    <UsersFilter @submit="updateFilters" />
    <vx-card>
      <div id="data-list-list-view" class="data-list-container">
        <add-new-data-sidebar
          :isSidebarActive="addNewDataSidebar"
          @closeSidebar="addNewDataSidebar = false"
          :form="formSideBar"
          :title="titleSideBar"
          :dados="dadosSideBar"
          @concluido="concluido"
        />

        <vs-table
          noDataText="Nenhum Usuário Encontrado"
          class="tablePrincipal"
          ref="table"
          multiple
          v-model="selected"
          :max-items="itemsPerPage"
          :data="itens"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          >
            <div class="flex flex-wrap-reverse items-center">
              <!------------ START  MENU DE AÇÕES ------------>
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                <div
                  class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
                >
                  <span class="mr-2">Ações</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>

                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="inativar"
                    v-if="$can($actionsDefault.Inativar, subjectPermission)"
                  >
                    <span>Inativar</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="reativar"
                    v-if="$can($actionsDefault.Inativar, subjectPermission)"
                  >
                    <span>Reativar</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="imprimir">
                    <span>Imprimir</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    v-if="$can($actionsDefault.Exportar, subjectPermission)"
                  >
                    <span>
                      <downloadexcel
                        :data="selected"
                        :fields="colunas"
                        name="usuarios.xls"
                        type="xls"
                        >Exportar</downloadexcel
                      >
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <!------------ END MENU DE AÇÕES ------------>

              <!------------ START ADD NOVO USUÁRIO ------------>
              <div
                class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-primary border border-solid border-primary"
                @click="openSideBar({})"
                v-if="$can($actionsDefault.Escrita, subjectPermission)"
              >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary"
                  >Adicionar novo Usuário</span
                >
              </div>
            </div>
            <!------------ END ADD NOVO USUÁRIO ------------>

            <div class="flex">
              <!------------ START ITENS POR PÁGINA ------------>
              <SelectPagination
                v-if="itens.length > 0"
                :currentPage="currentPage"
                :itemsPerPage="itemsPerPage"
                :length="count"
                @update="updateSelectPagination"
              />
              <!------------ END ITENS POR PÁGINA ------------>
            </div>
          </div>

          <!------------ START TITULO DA TABELA ------------>

          <template slot="thead">
            <vs-th sort-key="Nome">Nome</vs-th>
            <vs-th sort-key="Usuario">Email</vs-th>
            <vs-th sort-key="Usuario">Empresa</vs-th>
            <vs-th sort-key="Usuario">Nome da Empresa</vs-th>
            <vs-th sort-key="Status">Status</vs-th>
            <vs-th>Ações</vs-th>
          </template>
          <!------------ END TITULO DA TABELA ------------>

          <!------------ START TABELA ------------>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <vs-list-item :title="tr.nome" :subtitle="tr.Setor">
                    <template slot="avatar">
                      <vs-avatar />
                    </template>
                  </vs-list-item>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.email }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.tipoEmpresa }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.nomeEmpresa }}</p>
                </vs-td>

                <vs-td>
                  <vs-chip
                    :color="getStatusColor(tr.deletedAt)"
                    class="product-order-status"
                    >{{ getStatusString(tr.deletedAt) }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <div class="vx-col">
                      <vs-button
                        v-tooltip="'Detalhes do Usuário'"
                        radius
                        color="dark"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-search"
                        class="d-inline"
                        @click="opemModal(tr.idUsuario)"
                      ></vs-button>
                    </div>
                    <div
                      class="vx-col"
                      v-if="$can($actionsDefault.Escrita, subjectPermission)"
                    >
                      <vs-button
                        v-tooltip="'Editar Usuário'"
                        radius
                        color="success"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-edit"
                        class="d-inline"
                        @click="openSideBar(tr)"
                      ></vs-button>
                    </div>
                    <div class="vx-col">
                      <vs-button
                        radius
                        v-tooltip="'Historico de Alterações'"
                        color="#88abc2"
                        icon-pack="feather"
                        icon="icon-archive"
                        class="d-inline"
                        @click="abrirModalHistoricoUsuarios(tr)"
                      ></vs-button>
                    </div>
                    <div
                      class="vx-col"
                      v-if="$can('Reset de Senha', subjectPermission)"
                    >
                      <vs-button
                        radius
                        v-tooltip="'Resetar Senha'"
                        color="warning"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-lock"
                        class="d-inline"
                        @click="openModalSenha(tr.idUsuario)"
                      ></vs-button>
                    </div>
                    <div class="vx-col">
                      <vs-button
                        radius
                        v-tooltip="'Código de Acesso'"
                        color="primary"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-hash"
                        class="d-inline"
                        @click="openModalCodigoAcesso(tr.idUsuario)"
                      ></vs-button>
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>

        <div class="mt-6">
          <vs-pagination
            :total="parseInt(count / itemsPerPage) + 1"
            v-model="currentPage"
          ></vs-pagination>
        </div>

        <!------------ END TABELA ------------>

        <!------------ START INFORMAÇÕES DO USUÁRIO ------------>
        <ModalInfo
          :modalSelecionado="modalSelecionado"
          :popupActive="popupActive"
          :title="`Dados do ${entidade}`"
          @close="popupActive = false"
        ></ModalInfo>

        <Modal
          v-if="userAlteracao != {}"
          class="holamundo"
          :title="'Reset de Senha'"
          :active.sync="modalSenha"
          @close="modalSenha = false"
        >
          <vx-input-group class="mb-base">
            <vs-input
              class="w-full"
              placeholder="Nova Senha"
              v-model="senha"
              name="Senha"
              v-validate="{ required: true, min: 6 }"
            />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button color="success" @click="resetSenha()"
                  >Salvar
                </vs-button>
              </div>
            </template>
          </vx-input-group>
        </Modal>

        <Modal
          class="holamundo"
          :title="'Código de Acesso'"
          :active.sync="modalCodigoAcesso"
          @close="modalCodigoAcesso = false"
        >
          {{ this.codigoAcesso }}
        </Modal>
        <!------------ END INFORMAÇÕES DO USUÁRIO ------------>

        <ModalHistoricoAlteracoes
          :popupActive="popupAlteracoesActive"
          :tipo="tipoHistorico"
          :nome="nomeHistorico"
          :dadosConsulta="dadosConsultaHistorico"
          @close="fecharModalHistorico"
        ></ModalHistoricoAlteracoes>
      </div>
    </vx-card>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from './../Includes/SideBar';
import downloadexcel from 'vue-json-excel';
import ModalInfo from '../../components/ModalInfo';

import service from '../../services';
import jwt from 'jsonwebtoken';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import ModalHistoricoAlteracoes from '../modais/ModalHistoricoAlteracoes.vue';
import Modal from '../../components/Modal.vue';
import SelectPagination from '@/utils/list/header/SelectPagination.vue';
import UsersFilter from '@/views/filtros/UsersFilter.vue';

export default {
  components: {
    SelectPagination,
    UsersFilter,
    AddNewDataSidebar,
    downloadexcel,
    ModalInfo,
    ModalHistoricoAlteracoes,
    Modal,
  },
  props: ['subjectPermission'],
  data() {
    return {
      color: '#d0e0eb',
      codigoAcesso: null,
      idEmpresa: null,
      isAdmin: false,
      dadosSideBar: {},
      controllerGeral: 'Usuario',
      formSideBar: 'usuario',
      entidade: 'Usuário',
      titleSideBar: 'Adicionar Usuario',
      popupActive: false,
      popupAlteracoesActive: false,
      modalSenha: false,
      modalCodigoAcesso: false,
      modalSelecionado: [],
      userAlteracao: null,
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 50,
      currentPage: 1,
      count: 0,
      isMounted: false,
      addNewDataSidebar: false,
      senha: null,
      id_usuario: null,
      usuarios_regionais: [],
      regionaisUsuario: [],
      regionalDefault: [],
      idRegionais: [],
      dominios: {
        perfis: [],
        setores: [],
        escritorios: [],
      },
      userSearched: null,
      debounce: functions.debounce(this.buscaDados, 1000),
      tipoEmpresa: null,
      nomeEmpresa: null,
      dadosConsultaHistorico: [],
      tipoHistorico: 'Usuarios',
      nomeHistorico: '',
      filters: {},
    };
  },
  computed: {},
  watch: {
    currentPage() {
      this.buscaDados();
    },
    itemsPerPage() {
      this.buscaDados();
    },
    userSearched: {
      handler: function () {
        this.debounce();
      },
    },
  },
  methods: {
    resetSenha() {
      if (this.senha) {
        this.$vs.loading();
        service
          .post(this.controllerGeral, 'TrocarSenha', {
            idUsuario: this.userAlteracao.idUsuario,
            senha: this.senha,
          })
          .then(() => {
            notify.notifySuccess(this.$vs, 'Senha Alterada(s) com sucesso');
            this.senha = null;
            this.userAlteracao = null;
            this.modalSenha = false;
          })
          .catch((e) => notify.notifyFail(this.$vs, e))
          .finally(() => this.$vs.loading.close());
      }
    },
    verificaAdmin() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        if (decoded.nomePerfil == 'Super User') this.isAdmin = true;
      }
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    updateSelectPagination(value) {
      this.currentPage = 1;
      this.itemsPerPage = value;
    },
    async inativar() {
      if(!this.selected.length){
        notify.notifyFail(this.$vs, 'Selecione pelo menos um registro');
        return
      }
      const success = await this.handleStatus(false)

      if(success){
        notify.notifySuccess(this.$vs, 'Registro(s) inativado(s) com sucesso');
        this.buscaDados();
        this.selected = [];
      }
    },
    async reativar() {
      if(!this.selected.length){
        notify.notifyFail(this.$vs, 'Selecione pelo menos um registro');
        return
      }

      const success = await this.handleStatus(true)

      if(success){
        notify.notifySuccess(this.$vs, 'Registro(s) reativado(s) com sucesso');
        this.buscaDados();
        this.selected = [];
      }
    },
    async handleStatus(value) {
      try {
        this.$vs.loading();
        const promises = this.selected.map((item) => {
          const payload = {
            id: item.idUsuario,
            status: value,
          }
          return service.post('Usuario', 'handle-status', payload)
        });
        await Promise.all(promises);
        return true
      } catch (error) {
        notify.notifyFail(this.$vs, error)
        return false
      } finally {
        this.$vs.loading.close();
      }
    },
    updateFilters(filters) {
      this.filters = filters;
      this.currentPage = 1;
      this.buscaDados();
    },
    buscaDados() {
      this.selected = [];

      let url = `list-pagination/idEmpresa=${this.idEmpresa}`;

      if (this.currentPage && this.itemsPerPage) {
        url =
          url + `?page=${this.currentPage}&itemsPerPage=${this.itemsPerPage}`;
      }

      if (this.filters.name) {
        url = url + `&name=${this.filters.name}`;
      }
      if (this.filters.cpf) {
        url = url + `&cpf=${this.filters.cpf}`;
      }
      if (this.filters.email) {
        url = url + `&email=${encodeURIComponent(this.filters.email)}`;
      }
      if (this.filters.companyType) {
        url = url + `&companyType=${this.filters.companyType}`;
      }
      if (this.filters.status) {
        url = url + `&status=${this.filters.status}`;
      }
      if (this.filters.companies && this.filters.companies.length > 0) {
        url = url + `&companies=${this.filters.companies}`;
      }
      if (this.filters.profiles && this.filters.profiles.length > 0) {
        url = url + `&profiles=${this.filters.profiles}`;
      }

      this.$vs.loading();
      service
        .getAll(this.controllerGeral, {}, url)
        .then((res) => {
          this.itens = [];
          const itens = res.data.rows;
          this.count = res.data.count;

          itens.forEach((element) => {
            if (element.Usuarios_Empresa) {
              element.Empresa = element.Usuarios_Empresa.nome;
            }

            if (element.Usuarios_Perfil) {
              element.Perfil = element.Usuarios_Perfil.nomePerfil;
            }

            if (element.Usuarios_Regional) {
              element.Regional = element.Usuarios_Regional.nome;
            }

            if (element.Usuarios_Setor) {
              element.Setor = element.Usuarios_Setor.nomeSetor;
            }

            if (element.idRegional) {
              element.tipoEmpresa = 'Corretora';
              element.nomeEmpresa = element.Usuarios_Regional.nome;
            }
            if (element.idDivisao) {
              element.tipoEmpresa = 'Assessoria';
              element.nomeEmpresa = element.Usuarios_Divisao.nomeDivisao;
            }
            if (element.idConvenio) {
              element.tipoEmpresa = 'Convênio';
              element.nomeEmpresa = element.Usuarios_Convenio.nome;
            }

            let usuarioAdiconado = false;

            if (
              this.$can('Visualização Individual', 'Usuário') &&
              !usuarioAdiconado
            ) {
              if (element.idUsuario == this.id_usuario) {
                this.itens.push(element);
                usuarioAdiconado = true;
              }
            }

            if (
              this.$can('Visualização Completa', 'Usuário') &&
              !usuarioAdiconado
            ) {
              this.itens.push(element);
              usuarioAdiconado = true;
            }

            this.idRegionais = this.dominios.escritorios.map((item) => item.id);
            if (
              this.$can('Visualização Corretora', 'Usuário') &&
              !usuarioAdiconado
            ) {
              let elementFiltrado = null;
              elementFiltrado = this.idRegionais.find(
                (x) => x == element.idRegional,
              );

              if (elementFiltrado) {
                this.itens.push(element);
                usuarioAdiconado = true;
              }
            }

            delete element.Usuarios_Empresa;
            delete element.Usuarios_Perfil;
            // delete element.Usuarios_Regional;
            delete element.Usuarios_Setor;
            delete element.usuarios_regionais;
          });
          //this.itens = res.data;
          this.colunas = {};
          if (this.itens[0])
            Object.keys(this.itens[0]).forEach((element) => {
              if (
                element != 'createdAt' &&
                element != 'updatedAt' &&
                element != 'deletedAt' &&
                element.indexOf('id') != 0
              ) {
                this.colunas[element] = element;
              }
            });
        })
        .catch((e) => {
          notify.notifyFail(this.$vs, 'Nenhum registros encontrado');
        })
        .finally(() => this.$vs.loading.close());
    },
    openSideBar(dados) {
      dados.idUsuario == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = {
        ...dados,
        dominios: { ...this.dominios },
      };
      this.addNewDataSidebar = true;
    },
    openModalSenha(cod) {
      this.userAlteracao = {};
      this.modalSenha = true;
      this.userAlteracao = this.itens.find((x) => x.idUsuario == cod);
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      let item = { ...this.itens.find((x) => x.idUsuario == cod) };
      item = this.formataProgramaAfiliados(item);
      Object.keys(item).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    formataProgramaAfiliados(item) {
      if (item.ProgramaAfiliado) {
        item.ProgramaAfiliado = item.ProgramaAfiliado.nome;
      }
      if (item.UsuarioUpline) {
        item.UsuarioUpline = item.UsuarioUpline.nome;
      }
      return item;
    },
    concluido() {
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == null) return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
    openModalCodigoAcesso(cod) {
      this.codigoAcesso = this.itens.find(
        (x) => x.idUsuario == cod,
      ).codigoAcesso;
      this.modalCodigoAcesso = true;
    },
    abrirModalHistoricoUsuarios(item) {
      this.dadosConsultaHistorico = [
        {
          tabela: 'usuarios',
          id: item.idUsuario,
        },
      ];
      this.nomeHistorico = item.nome;
      this.popupAlteracoesActive = true;
    },
    fecharModalHistorico() {
      this.popupAlteracoesActive = false;
    },
    getRegionais() {
      service.getAll('Regional', {}, 'list-escritorios').then((res) => {
        res.data.forEach((element) => {
          this.dominios.escritorios.push({
            id: element.idRegional,
            label: element.nome,
            corretora: element.Corretora,
          });
        });
      });
    },
  },
  created() {
    this.getDecoded();
  },
  mounted() {
    this.isMounted = true;
    this.verificaAdmin();
    this.buscaDados();
    this.getRegionais();
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<!------------ END STYLE ------------>
